export const tu360Compras = {
  title: 'Tu360Compras',
  url: 'https://viajestu360compras.bancolombia.com',
  pressable: true,
  brandColor: '#59CBE8',
  categories: [
    {
      title: 'Viajes',
      icon: 'flight',
      actionButtonInfo: {
        title: 'Conocer más',
        type: 'button',
        url: 'https://viajestu360compras.bancolombia.com',
        hostname: 'viajestu360compras.bancolombia.com'
      },
      listOptions: [
        {
          title: '',
          options: [
            {
              title: 'Vuelos',
              url: 'https://viajestu360compras.bancolombia.com/vuelos',
              hostname: 'viajestu360compras.bancolombia.com/vuelos',
              delegated: '',
              isNew: false
            }, 
            {
              title: 'Paquetes',
              url: 'https://viajestu360compras.bancolombia.com',
              hostname: 'viajestu360compras.bancolombia.com',
              delegated: '',
              isNew: false
            }, 
            {
              title: 'Alojamientos',
              url: 'https://viajestu360compras.bancolombia.com/Alojamientos',
              hostname: 'viajestu360compras.bancolombia.com/Alojamientos',
              delegated: '',
              isNew: false
            },
            {
              title: 'Actividades',
              url: 'https://viajestu360compras.bancolombia.com/actividades',
              hostname: 'viajestu360compras.bancolombia.com/actividades',
              delegated: '',
              isNew: false
            },             
            {
              title: 'Disney',
              url: 'https://viajestu360compras.bancolombia.com/Disney',
              hostname: 'viajestu360compras.bancolombia.com/Disney',
              delegated: '',
              isNew: false
            },            
            {
              title: 'Renta de autos',
              url: 'https://viajestu360compras.bancolombia.com/Autos',
              hostname: 'viajestu360compras.bancolombia.com/Autos',
              delegated: '',
              isNew: true
            },
          ]
        },
      ]
    },
  ]
}
